module.exports = __webpack_public_path__ + "media/images/add-logo-5b389046fc640ac06923ce90784a30de.png";